import { NgModule } from '@angular/core';
import { CcsNglPrmrybtnComponent } from './ccs-ngl-prmrybtn.component';
import { ButtonModule } from 'primeng/button';


@NgModule({
  declarations: [
    CcsNglPrmrybtnComponent
  ],
  imports: [
    ButtonModule
  ],
  exports: [
    CcsNglPrmrybtnComponent,
    ButtonModule
  ]
})
export class CcsNglPrmrybtnModule { }
